import * as React from 'react';
import type { SiteWithSpaceName } from '@klareospace/pharos-lib-types';
import { cn } from '@klareospace/pharos-lib-web-utils';
import { useTranslation } from 'react-i18next';
import { useMasterContext } from '&/master';
import { SITE_TYPE_ICON_MAP } from '@klareospace/pharos-lib-web-utils';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface SiteResultProps {
  onClose: () => void;
  site: SiteWithSpaceName;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function SiteResult({ onClose, site }: SiteResultProps): React.JSX.Element {
  const { selectSite, siteId: currentSiteId } = useMasterContext();
  const { t } = useTranslation('common');
  const SiteIcon = SITE_TYPE_ICON_MAP[site.type];
  const isActive = site.id === currentSiteId;

  const handleSelect = (): void => {
    selectSite(site.id, site.spaceId);
    onClose();
  };

  return (
    <button
      className={cn(
        'flex items-center gap-2 px-2.5 py-2 mx-1 w-[calc(100%-0.5rem)] rounded-md transition-colors text-left group/site-result',
        isActive ? 'bg-accent' : 'hover:bg-muted',
      )}
      onClick={handleSelect}
      type="button"
    >
      <SiteIcon className="w-3.5 h-3.5 shrink-0" style={{ color: site.color }} />
      <span className="flex-1 text-xs truncate">{site.name}</span>
      <span
        className={cn(
          'text-[10px] text-muted-foreground truncate max-w-[80px] shrink-0',
          !isActive && 'group-hover/site-result:hidden',
        )}
      >
        {site.spaceName}
      </span>
      {!isActive && (
        <span className="text-[11px] text-primary font-medium hidden group-hover/site-result:inline">
          {t('mainSelector.select')}
        </span>
      )}
    </button>
  );
}
